export default __webpack_public_path__ + "static/media/svg-3.8773c443.svg";